"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ITEMS_PER_ROW = exports.default = void 0;
var _default = {
  SMALL: 16,
  LARGE: 64
};
exports.default = _default;
var ITEMS_PER_ROW = 4;
exports.ITEMS_PER_ROW = ITEMS_PER_ROW;